/**
 * GSC SHARED DSP UTILITIES
 * Pure mathematical functions for signal processing.
 */

// Cubic Hermite Interpolator
function cubicInterpolate(y0: number, y1: number, y2: number, y3: number, mu: number): number {
    const mu2 = mu * mu;
    const a0 = -0.5 * y0 + 1.5 * y1 - 1.5 * y2 + 0.5 * y3;
    const a1 = y0 - 2.5 * y1 + 2 * y2 - 0.5 * y3;
    const a2 = -0.5 * y0 + 0.5 * y2;
    const a3 = y1;
    return a0 * mu * mu2 + a1 * mu2 + a2 * mu + a3;
}

export function resampleCubic(data: Float32Array, fromRate: number, toRate: number): Float32Array {
    if (fromRate === toRate) return data;
    const ratio = fromRate / toRate;
    const newLength = Math.round(data.length / ratio);
    const out = new Float32Array(newLength);
    
    for (let i = 0; i < newLength; i++) {
        const pos = i * ratio;
        const idx = Math.floor(pos);
        const mu = pos - idx;
        
        const v0 = idx > 0 ? data[idx - 1] : data[idx];
        const v1 = data[idx];
        const v2 = idx + 1 < data.length ? data[idx + 1] : v1;
        const v3 = idx + 2 < data.length ? data[idx + 2] : v2;
        
        out[i] = cubicInterpolate(v0, v1, v2, v3, mu);
    }
    return out;
}

export function computeRMS(data: Float32Array): number {
    let sum = 0;
    const len = data.length;
    for(let i=0; i<len; i++) sum += data[i] * data[i];
    return 10 * Math.log10(sum / len + 1e-10);
}
